<template>
  <v-app v-if="!! userDoc.id">
    <drawer
      :drawer-prop="drawer"
      v-if="! showOnlyMain"
      :mini-variant-prop="miniVariant"
      @getDrawerState="getDrawerState"
    ></drawer>
    <toolbar @toggleDrawer="toggleDrawer" v-if="! showOnlyMain"></toolbar>
    
    <v-main>
      <v-container fluid grid-list-xl>
        <v-flex xs12 style="margin-bottom:12px;">
          <h3>{{ toolbarTitle }}</h3>
        </v-flex>

        <v-flex xs12>
          <v-fade-transition mode="out-in">
            <router-view></router-view>
          </v-fade-transition>
        </v-flex>
      </v-container>
    </v-main>

    <v-footer app  v-if="! showOnlyMain">
      <span>&nbsp; BEEVISION CO,LTD</span>
      <v-spacer/>
      <span>&copy; 2020</span>
    </v-footer>
  </v-app>

  <v-app v-else>
    <v-flex xs12 style="height: 100vh !important;">
      <v-fade-transition mode="out-in">
        <router-view></router-view>
      </v-fade-transition>
    </v-flex>
  </v-app>

</template>
<script>
import Drawer from "./views/layout/Drawer.vue";
import Toolbar from "./views/layout/Toolbar.vue";

export default {
  name: "App",
  components: {
    Drawer,
    Toolbar
  },

  data: () => ({
    drawer: true,
    miniVariant: false,
    events: ['click', 'mousemove', 'mousedown', 'scroll', 'keypress', 'load'],
    logoutTime: null,
  }),
  
  mounted() {
    this.events.forEach((e) => { window.addEventListener(e, this.resetTimer); });

    if (localStorage && localStorage.id) { this.$store.state.userDoc.id = localStorage.id; }
    if (localStorage && localStorage.username) { this.$store.state.userDoc.username = localStorage.username; }
    if (localStorage && localStorage.type) { this.$store.state.userDoc.type = localStorage.type; }
    if (localStorage && localStorage.contact_id) { this.$store.state.userDoc.contact_id = localStorage.contact_id; }
    if (localStorage && localStorage.position) { this.$store.state.userDoc.position = localStorage.position; }
    if (localStorage && localStorage.profile) { this.$store.state.userDoc.profile = localStorage.profile; }
    if (localStorage && localStorage.parent_id) { this.$store.state.userDoc.parent_id = localStorage.parent_id; }
    if (localStorage && localStorage.full_name) { this.$store.state.userDoc.full_name = localStorage.full_name; }
    if (localStorage && localStorage.phone) { this.$store.state.userDoc.phone = localStorage.phone; }
  },

  methods: {
    toggleDrawer() {
      this.drawer = true;
      if (this.$vuetify.breakpoint.xsOnly) {
        this.miniVariant = false;
      } else {
        this.miniVariant = !this.miniVariant;
      }
    },

    getDrawerState(val) {
      this.drawer = val;
    },

    setTimers() {
      let vm = this;
      vm.logoutTime = setTimeout(vm.logoutUser, 24 * 60 * 60 * 1000);
    },

    logoutUser() {
      let vm = this;
      if (vm.$router.history.current.name !== "login") {
        vm.$router.push({name: "login"});
      }
      vm.$store.state.userDoc.id = "";
      vm.$store.state.userDoc.username = "";
      vm.$store.state.userDoc = {};
      if(vm.$store.state.userDoc.phone){ vm.$store.state.userDoc.phone=""; } // just append so some where will not
      localStorage.clear();
    },

    resetTimer() {
      let vm = this;
      clearTimeout(vm.logoutTime);
      vm.setTimers();
    }
  },

  computed: {
     toolbarTitle(){
      let title = '';
      if(Object.hasOwnProperty.call(this.$route, "meta") && Object.hasOwnProperty.call(this.$route.meta, "breadCrumb")){
        title = this.$route.meta.breadCrumb;
      }
      return this.$t(title);
    },

    userDoc() {
      return this.$store.state.userDoc;
    },
    showOnlyMain(){
      return this.$route.name === 'home' || this.$route.name === 'page-not-found' ||  this.$route.name === '';
    }
  }
};

</script>